import { WorkflowDocumentConflictKinds } from "../kinds";
import { ReceptionSaveResultBase } from "../base";
import { WorkflowOperation } from "../items";
import { ReceptionDateTranslator } from "../ReceptionDateTranslator";
import { DocumentManageKinds } from "../../system";
import { WorkflowAutoRegisterResult } from ".";

// WF文書登録結果model
export class WorkflowDocumentSaveResult extends ReceptionSaveResultBase {
  public savedDocumentType: DocumentManageKinds;
  public conflictType: WorkflowDocumentConflictKinds;
  public conflictOperation: WorkflowOperation;
  public confirmButtonName: string;
  public isFirstNormalRegister: boolean;
  public workflowAutoRegisterResult: WorkflowAutoRegisterResult;

  private get isOperatorExist(): boolean {
    return (!!this.conflictOperation && !!this.conflictOperation.operator);
  }

  get conflictOperatorName(): string {
    return (this.isOperatorExist && this.conflictOperation.operator.user)
       ? this.conflictOperation.operator.user.name : "";
  }

  get conflictOperatorProfession(): string {
    return this.isOperatorExist ? this.conflictOperation.operator.professionName : "";
  }

  get conflictOperationTime(): string {
    const dateTranslator = new ReceptionDateTranslator();
    return this.conflictOperation ? dateTranslator.toDateTimeDispString(this.conflictOperation.operationDateTime) : "";
  }
}
